import React from "react";

export default function Signin({ current }) {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ height: window.innerHeight - 80 }}
      onClick={() => document.getElementById(current).click()}
    >
      <div className="bi bi-person-circle text-grey fs-xxl lh-1"></div>
      <div className=" text-muted mt-3">You need to Login</div>
    </div>
  );
}

// parle, dr.oatker, funfoods, tissue, tata, taj, rajdhani, shaktibhog, cadbury, mdh, harpic, lizol, genda-phenyl
